<template>
  <div class="col-12">
    <section class="section--title-page has-no-margin">
      <h3>Competenze professionali</h3>
      <!--          {{__('views.People.skills')}}-->
    </section>

    <input type="hidden" name="_token" :value="csrf" />

    <div class="form-group">
      <select v-model="selectedSkill" class="form-control">
        <option disabled value="">{{ __("misc.select") }}</option>
        <option v-for="(skill, index) in this.skills" :value="index">
          {{ skill }}
        </option>
      </select>
    </div>
    <div class="form-group">
      <select v-model="selectedLevel" class="form-control">
        <option disabled value="">{{ __("misc.select") }}</option>
        <option v-for="(level, index) in levels" :value="index">
          {{ level }}
        </option>
      </select>
    </div>
    <div class="form-buttons clear">
      <button @click="addRowSkill" class="btn btn--green" type="button">
        <i class="fa fa-plus-circle"></i> Aggiungi competenza
      </button>
    </div>
    <div class="clear has-padding-top has-padding-bottom"></div>

    <table class="table">
      <thead>
        <tr>
          <th></th>
          <th>Competenza</th>
          <th>Livello</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in skillsGet">
          <td>
            <button
              type="button"
              class="btn btn--only-icon-rounded btn--danger"
              @click="rmRowSkill(index)"
            >
              <i class="fas fa-trash"></i>
            </button>
          </td>
          <td>
            <input
              type="hidden"
              :value="row.skillId"
              :name="'skillsApplicant[' + index + '][skill_id]'"
            />
            {{ row.skillName }}
          </td>
          <td>
            <input
              type="hidden"
              :value="row.levelId"
              :name="'skillsApplicant[' + index + '][skill_level_id]'"
            />
            {{ row.levelName }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  methods: {
    // getSkills(){
    //   axios.get("/person-skills"+this.userUrl+"/"+this.person_id)
    //       .then((response) => {
    //         this.skillsGet  = response.data.skills;
    //         this.action     = response.data.action;
    //       });
    // },
    updateSkillLevel(row, event) {},
    rmRowSkill(rowIndex) {
      //Delete element
      Vue.delete(this.skillsGet, rowIndex);
    },
    addRowSkill() {
      //Check if
      if (this.selectedSkill === "" || this.selectedLevel === "") {
        alert("Non puoi lasciare campi vuoti");
        return;
      }

      this.skillsGet.push({
        skillId: this.selectedSkill,
        levelId: this.selectedLevel,
        skillName: this.skills[this.selectedSkill],
        levelName: this.levels[this.selectedLevel],
      });
    },
  },
  mounted() {},
  data() {
    return {
      action: "",
      selectedSkill: "",
      selectedLevel: "",
      skillsGet: [],
      userUrl: this.is_admin ? "" : "-user",
      csrf: document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content"),
    };
  },
  props: {
    // person_id: {
    //     type: Number,
    //     required: true
    // },
    skills: {
      type: Object,
      required: true,
    },
    levels: {
      type: Object,
      required: true,
    },
    // is_admin:{
    //   type: Boolean,
    //   required : true
    // },
  },
};
</script>
